import { z } from "zod";
export const HTTP_API_MAJOR = "v1";
export const NOTIFICATION_PROTOCOL_VERSION = 1;
export const LEGACY_BASELINE_COMMIT = "854133aac74c85c8c9135b6ffd17bd1c051df36d";
export const ApiInfoSchema = z.object({
    httpApiMajors: z.array(z.string()),
    notificationProtocolVersions: z.array(z.number().int().positive()),
    capabilities: z.array(z.string()),
    contractRevision: z.string(),
});
export const LEGACY_API_INFO = {
    httpApiMajors: [HTTP_API_MAJOR],
    notificationProtocolVersions: [NOTIFICATION_PROTOCOL_VERSION],
    capabilities: [],
    contractRevision: LEGACY_BASELINE_COMMIT,
};
export function supportsCurrentProtocol(info) {
    return info.httpApiMajors.includes(HTTP_API_MAJOR) &&
        info.notificationProtocolVersions.includes(NOTIFICATION_PROTOCOL_VERSION);
}
